export default (app) => {
  app.config.globalProperties.listToJson = (list, o = {}) => {
    const { name, value } = o
    return list.reduce((o, item) => {
      return { ...o, [item[name || 'dictCode']]: item[value || 'dictName'] }
    }, {})
  }

  app.config.globalProperties.noSpaces = (event) => {
    if (event.keyCode == 32) {
      event.returnValue = false
    }
  }
}